import React, { useMemo } from "react";
import api from "../services/api";

// created by ChatGPT on 2025-11-24 15:10 – Bag page for multi-product checkout
const BagPage = ({ items = [], onRemoveFromBag }) => {
  const totalAmount = useMemo(
    () =>
      items.reduce((sum, item) => {
        const costNumber = Number(item.cost) || 0;
        return sum + costNumber;
      }, 0),
    [items]
  );

  const handleBuyAll = async () => {
    if (!items.length) {
      alert("Your bag is empty");
      return;
    }

    try {
      console.log("🛒 Creating payment link for all bag items...");

      const payload = {
        amount: totalAmount,
        productId: "BAG_MULTI", // assumption: backend accepts generic id
        productName: `Bag items (${items.length})`,
        selectedImage: items[0]?.imageUrl || "",
        buyerMobile: "8179607738",
        // optional: send full item list for backend reference
        bagItems: items.map((i) => ({
          id: i._id,
          name: i.productName,
          cost: i.cost,
        })),
      };

      const response = await api.post("/payment/create", payload);

      if (response.data.success && response.data.link) {
        window.location.href = response.data.link;
      } else {
        alert("Failed to create payment link for bag");
      }
    } catch (err) {
      console.error("❌ BUY ALL ERROR:", err);
      alert("Payment failed. Try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ width: "100%", maxWidth: "900px" }}>
        <h1 style={{ marginBottom: "20px" }}>Your Bag</h1>

        {items.length === 0 ? (
          <p>Your bag is empty.</p>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "24px",
              }}
            >
              {items.map((item) => (
                <div
                  key={item._id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "white",
                    padding: "10px 14px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                    gap: "12px",
                  }}
                >
                  <img
                    src={item.imageUrl}
                    alt={item.productName}
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "cover",
                      borderRadius: "6px",
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        marginBottom: "4px",
                      }}
                    >
                      {item.productName}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      ₹{item.cost}
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      onRemoveFromBag && onRemoveFromBag(item._id)
                    }
                    style={{
                      padding: "6px 10px",
                      background: "white",
                      color: "#dc3545",
                      border: "1px solid #dc3545",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "white",
                padding: "14px 16px",
                borderRadius: "10px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginBottom: "4px",
                  }}
                >
                  Total
                </div>
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  ₹{totalAmount}
                </div>
              </div>

              <button
                onClick={handleBuyAll}
                style={{
                  padding: "10px 22px",
                  background: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Buy All
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BagPage;
